/*
 * Smores Lineup — mobile slider nav.
 *
 * The grid uses CSS scroll-snap on mobile (see smores-lineup.css). The
 * pagination dots and arrows here drive the scroll position via plain
 * scrollLeft math. On desktop the pagination is hidden by CSS and the
 * grid is a static 3-column layout, so this code is a no-op there.
 */
class SmoresLineup extends HTMLElement {
  connectedCallback() {
    this.track = this.querySelector('.smores-lineup__grid');
    this.cards = [...this.querySelectorAll('.smores-card')];
    this.dots = [...this.querySelectorAll('.smores-lineup__dot')];
    this.prev = this.querySelector('.smores-lineup__arrow--prev');
    this.next = this.querySelector('.smores-lineup__arrow--next');
    if (!this.track || this.cards.length === 0) return;

    this.dots.forEach((dot, i) => dot.addEventListener('click', () => this.go(i)));
    if (this.prev) this.prev.addEventListener('click', () => this.step(-1));
    if (this.next) this.next.addEventListener('click', () => this.step(1));

    this.track.addEventListener('scroll', () => this.updateActive(), { passive: true });
    this.updateActive();
  }

  step(delta) {
    const current = this.currentIndex();
    const target = Math.max(0, Math.min(this.cards.length - 1, current + delta));
    this.go(target);
  }

  go(i) {
    const target = this.cards[Math.max(0, Math.min(this.cards.length - 1, i))];
    if (!target) return;
    const left = target.offsetLeft - this.track.offsetLeft;
    this.track.scrollTo({ left, behavior: 'smooth' });
  }

  currentIndex() {
    const scrollLeft = this.track.scrollLeft;
    let closest = 0;
    let minDist = Infinity;
    this.cards.forEach((card, i) => {
      const dist = Math.abs(card.offsetLeft - this.track.offsetLeft - scrollLeft);
      if (dist < minDist) { minDist = dist; closest = i; }
    });
    return closest;
  }

  updateActive() {
    const i = this.currentIndex();
    this.dots.forEach((dot, di) => dot.setAttribute('aria-current', String(di === i)));
  }
}

if (!customElements.get('smores-lineup')) {
  customElements.define('smores-lineup', SmoresLineup);
}